module.exports = __webpack_public_path__ + "img/10551379_L.f2fc03d7.png";